import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PersonIcon from "@mui/icons-material/Person";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../main/backend/auth/Logout";
import { sidebarConfig } from "../main/config/sidebar.config";
import { USER_ID } from "../main/utilities/Constants";
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerFooter = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  flexDirection: "column",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Sidebar({ open, handleDrawerClose }) {
  const navigate = useNavigate();

  const location = useLocation();
  return (
    <Drawer variant="permanent" open={open}>
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        height={"100vh"}
        sx={{
          backgroundColor: "rgba(27,52,72,255)",
          color: "white",
        }}
      >
        <Box>
          <Box
            height={100}
            sx={{
              paddingLeft: open ? 2 : 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={!open ? "/mobile-logo.svg" : "/logo_product.svg"}
              alt="Logo"
            />
          </Box>
          <Box height={25}>
            <Typography
              noWrap
              component="div"
              sx={{
                color: "white",
                display: "flex",
                justifyContent: "center",
                opacity: open ? 1 : 0,
              }}
            >
              Hi, {sessionStorage.getItem(USER_ID)}
            </Typography>
          </Box>
          <List>
            {sidebarConfig.map((item, index) => (
              <ListItem
                key={item.title}
                disablePadding
                sx={{
                  display: "block",
                  borderLeft:
                    location.pathname === item.path
                      ? "4px solid rgba(0,114,206,255)"
                      : "none",
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    navigate(item.path);
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                      color: "white",
                    }}
                  >
                    <item.icon />
                  </ListItemIcon>
                  <ListItemText
                    sx={{ opacity: open ? 1 : 0, marginLeft: -1.4 }}
                    disableTypography
                    primary={
                      <Typography variant="body2" style={{ color: "#FFFFFF" }}>
                        {item.title}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
        <DrawerFooter>
          <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2,
              }}
              onClick={async () => {
                await logout();
                sessionStorage.clear();
                localStorage.clear();
                document.cookie.split(";").forEach((c) => {
                  document.cookie = c
                    .replace(/^ +/, "")
                    .replace(
                      /=.*/,
                      "=;expires=" + new Date().toUTCString() + ";path=/"
                    );
                });
                if ("caches" in window) {
                  caches.keys().then((names) => {
                    for (let name of names) caches.delete(name);
                  });
                }
                window.location.href = process.env.REACT_APP_LOGOUT_URI;
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                  color: "white",
                }}
              >
                <PersonIcon />
              </ListItemIcon>
              <ListItemText
                sx={{ opacity: open ? 1 : 0, marginLeft: -1.4 }}
                disableTypography
                primary={
                  <Typography variant="body2" style={{ color: "#FFFFFF" }}>
                    Logout
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
          <Box>
            {open ? "Collapse" : ""}
            <IconButton
              onClick={handleDrawerClose}
              sx={{
                color: "white",
                size: "large",
                transform: open ? "translateX(65px)" : "translateX(4px)",
                transition: "transform 0.3s",
              }}
            >
              {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </Box>
        </DrawerFooter>
      </Box>
    </Drawer>
  );
}
